module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "chartContainer",
    staticClass: "chart-gauge"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61b9e4ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/Gauge.vue
// module id = 1106
// module chunks = 0